const splitOnLastOccurrence = (str: string, separator: string) => {
  const lastIndex = str.lastIndexOf(separator);
  if (lastIndex >= 0) {
    return [str.slice(0, lastIndex), str.slice(lastIndex + separator.length)];
  }
  return null;
};

const isPositiveInteger = (str: string) => {
  const numberRegex = /^[0-9]+$/g;
  if (!numberRegex.test(str)) {
    return false;
  }
};
export const nextName = (existingNames: string[], fromName: string) => {
  if (!existingNames?.includes(fromName) || !fromName) {
    return fromName;
  }

  const [originalName, startIndex] = (() => {
    const nameSplit = splitOnLastOccurrence(fromName, ' ');

    if (!nameSplit || !isPositiveInteger(nameSplit[1])) {
      return [fromName, 2];
    }
    return [nameSplit[0], parseInt(nameSplit[1], 10)];
  })();

  for (let i = startIndex; ; i += 1) {
    const proposedNextName = `${originalName} ${i}`;
    if (!existingNames.includes(proposedNextName)) {
      return proposedNextName;
    }
  }
};
